/**
 * Show this component after a x seconds delay.
 *
 * When user close popup wait x hours to show again
 * to prevent "spaming" it to the user.
 *
 *
 * TO-DO: Form Submit and store info that user already has newsletter
 * to prevent spaming this again
 *
 */

import Cookies from "js-cookie";
import Modal from './modal';

export default {
	name: 'NewsletterPopup',
	components: {
		Modal
	},
	props: {
		delay: {
			type: Number,
			default: 15
		}
	},
	name: 'NewsletterPopup',
	data() {
		return {
			waitHoursToShow: 3,
			showNewsletter: false,
		}
	},
	mounted() {
		this.openNewsletter();
	},
	methods: {
		submitForm() {
			setTimeout(() => {
				this.$refs.email_newsletter.value = "";
				this.closeNewsletter();
			}, 500);
		},

		openNewsletter() {
			let newsletterCookie = Cookies.get('newsletterShown');

			if (!newsletterCookie) {
				setTimeout(() => {
					this.showNewsletter = true;
				}, (this.delay * 1000))
			}

		},

		closeNewsletter() {
			Cookies.set(
				'newsletterShown',
				true	,
				// {
				// 	expires: new Date(new Date().getTime() + (this.waitHoursToShow * 3600 * 1000))
				// }
			)

			this.showNewsletter = false;
		}
	}
}
